// Attribution des affiliés.
//
// Un affilié partage selfcntrl.com/…?via=CODE. À l'arrivée, on garde le code
// (et un identifiant de visiteur tiré au hasard) pendant WINDOW_DAYS, dans
// localStorage ET dans un cookie : si l'un est vidé, l'autre tient. Le code
// est envoyé UNE fois, à l'inscription (RegisterForm) ; c'est le serveur qui
// le valide et rattache le compte. Les paiements suivent tout seuls, côté
// webhook Stripe.
//
// Dernier clic gagnant : un nouveau lien ?via= remplace l'ancien.
//
// Les balises (clic d'arrivée, clic vers /register) ne servent qu'aux
// compteurs de l'affilié. Elles ne passent pas par la porte du consentement
// publicitaire (trackingAllowed) : c'est de l'attribution commerciale, pas du
// ciblage — mais elles se taisent en mode test, comme le reste.
import { BASE } from './api'
import { DEV_MODE } from './tracking'

const KEY = 'selfcntrl.aff.v1'
const COOKIE = 'sc_aff'
// ⚠️ Même valeur que AFF_WINDOW_DAYS dans CTRL-BACKEND/config/affiliates.php
// (l'espace affilié l'annonce).
const WINDOW_DAYS = 60
const CODE_RE = /^[a-z0-9][a-z0-9_-]{1,38}$/

function newVid () {
  const abc = 'abcdefghijklmnopqrstuvwxyz0123456789'
  const r = new Uint8Array(16)
  try { crypto.getRandomValues(r) } catch { for (let i = 0; i < 16; i++) r[i] = Math.random() * 256 }
  return Array.from(r, b => abc[b % abc.length]).join('')
}

function read () {
  let d = null
  try { d = JSON.parse(localStorage.getItem(KEY) || 'null') } catch { /* stockage refusé */ }
  if (!d) {
    // Repli sur le cookie : « code.vid.horodatage ».
    const m = document.cookie.match(/(?:^|;\s*)sc_aff=([^;]*)/)
    if (m) {
      const [code, vid, at] = decodeURIComponent(m[1]).split('.')
      d = { code, vid, at: Number(at) }
    }
  }
  if (!d || !CODE_RE.test(d.code || '')) return null
  if (!d.at || Date.now() - d.at > WINDOW_DAYS * 86400e3) return null
  return d
}

function write (d) {
  try { localStorage.setItem(KEY, JSON.stringify(d)) } catch { /* tant pis, le cookie suit */ }
  try {
    const secure = window.location.protocol === 'https:' ? '; Secure' : ''
    document.cookie = `${COOKIE}=${encodeURIComponent(`${d.code}.${d.vid}.${d.at}`)}; Max-Age=${WINDOW_DAYS * 86400}; Path=/; SameSite=Lax${secure}`
  } catch { /* idem */ }
}

function send (kind, d) {
  if (DEV_MODE) {
    // eslint-disable-next-line no-console
    console.info('[mode test] balise affilié non envoyée —', kind, d.code)
    return
  }
  const url = `${BASE}/aff/track.php?k=${kind}`
  const body = JSON.stringify({ c: d.code, v: d.vid, p: window.location.pathname })
  try {
    // text/plain : pas de pré-vérification CORS, que sendBeacon ne survit pas.
    const blob = new Blob([body], { type: 'text/plain;charset=UTF-8' })
    if (navigator.sendBeacon?.(url, blob)) return
  } catch { /* repli */ }
  try {
    fetch(url, { method: 'POST', body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(() => {})
  } catch { /* tant pis */ }
}

/** Au chargement (index.js) : un ?via= dans l'adresse = un clic d'affilié. */
export function captureAffiliate () {
  let raw = null
  try { raw = new URLSearchParams(window.location.search).get('via') } catch { return }
  if (!raw) return
  const code = raw.trim().toLowerCase().slice(0, 40)
  if (!CODE_RE.test(code)) return
  const prev = read()
  const d = { code, vid: prev?.vid || newVid(), at: Date.now() }
  write(d)
  send('click', d)
}

/** Clic sur un bouton qui mène à /register (écouteur global de App.js). */
export function affiliateCta () {
  const d = read()
  if (d) send('cta', d)
}

/** À joindre à l'inscription. Vide si personne ne nous a envoyé ce visiteur. */
export function getAffiliate () {
  const d = read()
  return d ? { aff: d.code, aff_vid: d.vid } : {}
}
